module.exports = __webpack_public_path__ + "media/images/athletes/3576-bc09038ee267c342372ddaa364667ccf.png";